:host button.sc-vx-wishlist {
  display: flex;
  border: none;
  background-color: white;
  border-radius: 100%;
  padding: 8px;
}
:host button.sc-vx-wishlist:hover {
  cursor: pointer;
  border: none;
}
:host button.sc-vx-wishlist slot-fb {
  display: flex;
}
:host .wishlist-icon {
  filter: invert(73%) sepia(87%) saturate(5813%) hue-rotate(328deg) brightness(98%) contrast(87%);
}